'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React, { useState } from 'react';
import { useParams } from 'next/navigation';
import TestimonialTile from 'shared/components/TestimonialTile';
import {
  Container,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Fade,
} from 'reactstrap';
import Cta from 'shared/components/CtaBtn';
import Image from 'next/image';
import Link from 'next/link';
import useScrollHeight from '../hooks/useScrollHeight';

const app = process.env.NEXT_PUBLIC_APP;

function AboutNl({ testimonial }: { testimonial: boolean }) {
  const { locale } = useParams();
  const scrollHeight = useScrollHeight();
  const [activeTab, setActiveTab] = useState('1');
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  return (
    <>
      <Container>
        <Row className="position-relative">
          <Col lg={{ offset: 3, size: 9 }} className="d-lg-flex justify-content-lg-end">
            <div id="main-cta" className={scrollHeight > 500 ? 'fixed' : ''}>
              <Link href={app === 'werkenbijsynergie.be' ? '/jobs' : `/${locale}/jobs`}>
                <Button color="yellow" className="text-dark px-4 pt-2 pb-2">
                  Je droomjob is 1 klik verwijderd
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
      <section className="pt-5 pb-4 pb-lg-5">
        <Container className="mb-4">
          <Row>
            <Col lg={6} className="px-lg-5">
              <p>
                Even voorstellen. <strong>Synergie Belgium</strong>, dat zijn 500 collega’s. Meer dan 70 kantoren en in-house
                teams bij bedrijven. Vier gespecialiseerde afdelingen - Interim, Careers, Construct en S&you. Allemaal gericht op
                één doel: <strong>de juiste persoon op de juiste werkplek</strong>. Wat we precies doen? We helpen jou groeien,
                als werknemer of werkgever. Samen maken we werk van jouw werk. In België, al meer dan 25 jaar.
              </p>
              <p>Denk je nu spontaan aan uitzendwerk? Dat mag. Maar denk ook verder.</p>
            </Col>
            <Col lg={6} className="px-lg-5">
              <p>
                We zorgen voor extra personeel op piekmomenten, maar ook voor bedienden in vast dienstverband en de juiste
                professionals voor projecten. In onze zoektocht kijken wij altijd verder dan het cv.
              </p>
              <p>
                Je mag ook letterlijk verder denken. Over de grenzen heen. Via Synergie Belgium log je in op een internationaal
                netwerk:{' '}
                <a href="https://www.synergie.com" target="__blank" rel="noopener noreferrer">
                  de hr-groep Synergie
                </a>
                , met 750 Synergie-vestigingen in 17 landen, 4.400 medewerkers, 95.000 bedrijven als klant. In Europa staat
                Synergie <strong>nr. 5 in Europa</strong> en <strong>nr. 1 op de Franse uitzendmarkt</strong>.
              </p>
              <a
                className="align-self-end"
                href="https://www.synergiejobs.be/nl/blog/5e46ce40127dca5674685f3f/julie-calewaert-co-director-bij-louis-culot"
                target="_blank"
                rel="noreferrer"
              >
                <Cta className="cta border-solid btn-outline-primary" type="button">
                  Lees hier hoe we een kmo helpen
                </Cta>
              </a>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4 bg-light">
        <Container className="mt-4 mb-4">
          <h2 className="text-uppercase">Hoe doen wij precies wat jij nodig hebt?</h2>

          <p className="pt-3 pb-3">
            We zeiden het al: Synergie, dat zijn vier gespecialiseerde afdelingen, elk met hun eigen focus. Zo krijg je precies
            wat je nodig hebt - ook de synergie tussen divisies, wanneer dat nodig is. Want ‘samen’ gaat alles beter.
          </p>

          <Nav tabs className="d-flex">
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '1' ? ' active' : ''}`}
                onClick={() => {
                  toggle('1');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/interim.svg"
                  alt="Interim Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">Synergie Jobs</span>
              </NavLink>
            </NavItem>
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '2' ? ' active' : ''}`}
                onClick={() => {
                  toggle('2');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/construct.svg"
                  alt="Construct Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">Synergie Construct</span>
              </NavLink>
            </NavItem>
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '3' ? ' active' : ''}`}
                onClick={() => {
                  toggle('3');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/careers.svg"
                  alt="Careers Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">Synergie Careers</span>
              </NavLink>
            </NavItem>
            <NavItem className="flex-grow-1">
              <NavLink
                className={`d-flex justify-content-center align-items-center p-3${activeTab === '4' ? ' active' : ''}`}
                onClick={() => {
                  toggle('4');
                }}
              >
                <Image
                  className="d-inline-block me-0 me-lg-3"
                  src="/icons/about/sandyou.svg"
                  alt="Division Sandyou Icon"
                  height={30}
                  width={30}
                />
                <span className="d-none d-lg-inline-block">S&you</span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="border border-secondary border-top-0">
            <TabPane tabId="1">
              <Card body className="p-5">
                <Fade in={activeTab === '1'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    Synergie Jobs
                  </CardTitle>
                  <CardText>
                    Onze consultants werken nauw samen met zowel KMO’s als grote bedrijven, en matchen talent aan bedrijven voor
                    interimwerk, tijdelijke jobs met uitzicht op een vast contract én vaste aanwervingen. We rekruteren profielen
                    binnen diverse jobdomeinen zoals logistiek, productie, techniek, sales & retail, schoonmaak en horeca.
                  </CardText>
                  <a href="https://www.synergiejobs.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Ga naar de website
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
            <TabPane tabId="2">
              <Card body className="p-5">
                <Fade in={activeTab === '2'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    Synergie Construct
                  </CardTitle>
                  <CardText>
                    Hier richten we ons op <strong>arbeiders</strong> voor alle domeinen van de <strong>bouwsector</strong>. De
                    juiste m/v op de juiste werf, dat is de uitdaging.
                    <br /> Focus: veiligheid. Onze consulenten hebben allemaal een VCU-certificaat, onze uitzendkrachten een
                    VCA-attest.
                  </CardText>
                  <a href="https://www.synergieconstruct.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Ga naar de website
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
            <TabPane tabId="3">
              <Card body className="p-5">
                <Fade in={activeTab === '3'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    Synergie Careers
                  </CardTitle>
                  <CardText>
                    In deze afdeling staan <strong>bedienden</strong> centraal, voor uitzendwerk of meteen vast werk.
                    <br />
                    Onze consultants gaan voor <strong>de best mogelijke match</strong> tussen kandidaten en bedrijven. Altijd
                    gericht op een langetermijnrelatie.
                  </CardText>
                  <a href="https://www.synergiecareers.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Ga naar de website
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
            <TabPane tabId="4">
              <Card body className="p-5">
                <Fade in={activeTab === '4'} timeout={200}>
                  <CardTitle tag="h3" className="text-uppercase">
                    S&you
                  </CardTitle>
                  <CardText>
                    Dit is de divisie van de HR-experts in de werving en selectie van{' '}
                    <strong>gespecialiseerde bedienden en kaderleden</strong>. <br />
                    Onze HR Business Partners bekijken elke vacature van dichtbij en leveren 100% maatwerk.
                  </CardText>
                  <a href="https://www.sandyou.be/" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Ga naar de website
                    </Cta>
                  </a>
                </Fade>
              </Card>
            </TabPane>
          </TabContent>
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4">
        <Container className="mt-4 mb-4">
          <TestimonialTile
            quote="Synergie is een hecht team met één missie: duurzame oplossingen creëren voor onze kandidaten en klanten in een evoluerende arbeidsmarkt."
            name="TOM VANOIRBEEK"
            imagePath="/images/tom_vanoirbeek.jpg"
            position="CEO SYNERGIE BELGIUM"
            quoteColor="var(--bs-warning)"
          />
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4 bg-light">
        <Container className="mt-4 mb-4">
          <Row>
            <Col lg={{ size: 6, order: 2 }} className="d-flex justify-content-center align-items-center">
              <svg
                className="bigIcon p-3 mb-3 mb-lg-0"
                xmlns="http://www.w3.org/2000/svg"
                width="200"
                height="200"
                viewBox="0 0 38.08 34.5"
              >
                <g id="Group_8" data-name="Group 8" transform="translate(-693.136 -355.087)">
                  <line
                    id="Line_22"
                    data-name="Line 22"
                    y2="15.2"
                    transform="translate(712.176 374.127)"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <line
                    id="Line_23"
                    data-name="Line 23"
                    x1="8.8"
                    transform="translate(712.176 374.127)"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <line
                    id="Line_24"
                    data-name="Line 24"
                    x2="8.8"
                    transform="translate(703.376 374.127)"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M727.382,369.336l-4.806,2.391h-4.8a2.4,2.4,0,0,1-2.4-2.4l5.6-.8s3.7-3.2,4.8-3.2l2.4,0a2.407,2.407,0,0,1,2.4,2.4v10.4a4.012,4.012,0,0,1-4,4h-4.8l-3.2,7.2"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M724.976,362.931a3.229,3.229,0,0,0,3.2-3.2v-.8a3.2,3.2,0,1,0-6.4,0v.8A3.229,3.229,0,0,0,724.976,362.931Z"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M724.976,370.927v6.4h-4.184a3.449,3.449,0,0,0-3.016,2.4l-3.177,9.6"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M696.97,369.336l4.806,2.391h4.8a2.4,2.4,0,0,0,2.4-2.4l-5.6-.8s-3.7-3.2-4.8-3.2l-2.4,0a2.407,2.407,0,0,0-2.4,2.4v10.4a4.012,4.012,0,0,0,4,4h4.8l3.2,7.2"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M699.376,362.931a3.229,3.229,0,0,1-3.2-3.2v-.8a3.2,3.2,0,1,1,6.4,0v.8A3.229,3.229,0,0,1,699.376,362.931Z"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                  <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M699.376,370.927v6.4h4.184a3.449,3.449,0,0,1,3.016,2.4l3.177,9.6"
                    fill="none"
                    stroke="#222E50"
                    strokeLinejoin="round"
                    strokeWidth="0.8"
                  />
                </g>
              </svg>
            </Col>
            <Col lg={{ size: 6, order: 1 }}>
              <h2 className="text-uppercase">Wat is typisch Synergie</h2>
              <p className="pt-3 pb-3">
                Synergie wérkt, zoveel is zeker. Dat bewijzen de cijfers. Sinds 2010 hebben we onze omzet verdubbeld. Waarom werkt
                Synergie voor jou, wat is de sleutel tot dit succes? Dat is de typische Synergie-cultuur, met drie keywords:{' '}
                <strong>no- nonsense</strong>, een <strong>persoonlijke aanpak</strong> en een{' '}
                <strong>duurzame samenwerking</strong>.
              </p>
              <div>
                <p>Wat maakt Synergie anders dan de anderen?</p>
                {app === 'werkenbijsynergie.be' ? (
                  <a href="https://www.synergiejobs.be/nl/synergie-values" target="_blank" rel="noopener noreferrer">
                    <Cta className="cta red" type="button">
                      Ontdek onze vijf basiswaarden
                    </Cta>
                  </a>
                ) : (
                  <Link href={`/${locale}/synergie-values`}>
                    <Cta className="cta red" type="button">
                      Ontdek onze vijf basiswaarden
                    </Cta>
                  </Link>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4">
        <Container className="mt-4 mb-4">
          <p className="text-center mt-3 mb-3 w-75 mx-auto">
            Je zal het snel merken: als <strong>challenger op de markt</strong> zijn we ondernemers. We zijn dus niet bang om
            initiatief te nemen, kansen te benutten en mogelijkheden te creëren.
          </p>
          <h2 className="p-4 text-uppercase text-center">Waaraan herken je ons nog meer?</h2>
          <Row>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/communicate.svg"
                  alt="icon"
                  height={96}
                  width={96}
                />
                <p className="border-primary border-top pt-2 text-center">
                  We werken graag samen en houden van open communicatie
                </p>
              </div>
            </Col>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/support.svg"
                  alt="icon"
                  height={96}
                  width={96}
                />
                <p className="border-primary border-top pt-2 text-center">
                  We ondersteunen elkaar maximaal en trainen onze veerkracht.
                </p>
              </div>
            </Col>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/dynamic.svg"
                  alt="icon"
                  height={96}
                  width={96}
                />
                <p className="border-primary border-top pt-2 text-center">
                  We leren voortdurend uit onze ervaringen, durven onszelf in vraag te stellen, hechten veel belang aan feedback,
                  denken oplossingsgericht, streven naar altijd beter.
                </p>
              </div>
            </Col>
            <Col sm="6">
              <div className="px-3 pt-1 pb-1 ms-lg-5 me-lg-5 mt-3 mb-3">
                <Image
                  className="d-block mx-auto p-2 mt-2 mb-2"
                  src="/icons/about/handson.svg"
                  alt="icon"
                  height={96}
                  width={96}
                />
                <p className="border-primary border-top pt-2 text-center">
                  Onze aanpak is toegankelijk, hands-on en constructief.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="d-flex justify-content-center">
          {app === 'werkenbijsynergie.be' ? (
            <a
              className="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
              href={`https://www.synergiejobs.be/${locale}/agencies`}
            >
              Maak een afspraak en ontdek het zelf
            </a>
          ) : (
            <Link href={`/${locale}/agencies`}>
              <Cta className="cta red" type="button">
                Maak een afspraak en ontdek het zelf
              </Cta>
            </Link>
          )}
        </div>
      </section>
      <section className="pt-lg-5 pb-lg-5 pt-4 pb-4">
        <Container className="mt-4 mb-4">
          <TestimonialTile
            quote="We vinden het belangrijk dat onze collega’s zich goed voelen bij Synergie en
            vooral dat ze zichzelf kunnen zijn."
            name="VERONIQUE VAN DE PEER"
            imagePath="/images/veronique_van_de_peer.jpg"
            position="HR-MANAGER BIJ SYNERGIE"
            quoteColor="var(--bs-warning)"
          />
        </Container>
      </section>
      {app !== 'werkenbijsynergie.be' && (
        <section className="pt-lg-5 pb-lg-5 pt-4 pb-4 bg-light">
          <Container className="mt-4 mb-4 ">
            <Row>
              <Col lg="6" className="d-flex  align-items-center">
                <svg
                  className="bigIcon d-block mx-auto p-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="200"
                  height="200"
                  viewBox="0 0 38.08 37.44"
                >
                  <g id="Group_9" data-name="Group 9" transform="translate(-692.276 -443.123)">
                    <path
                      id="Path_42"
                      data-name="Path 42"
                      d="M726.516,470.963v4h-4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_25"
                      data-name="Line 25"
                      x2="5.6"
                      y2="5.6"
                      transform="translate(720.916 469.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_43"
                      data-name="Path 43"
                      d="M726.516,453.363v-4h-4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_26"
                      data-name="Line 26"
                      y1="5.6"
                      x2="5.6"
                      transform="translate(720.916 449.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_44"
                      data-name="Path 44"
                      d="M726.516,465.363l3.2-3.2-3.2-3.2"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_27"
                      data-name="Line 27"
                      x1="8"
                      transform="translate(721.716 462.163)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_45"
                      data-name="Path 45"
                      d="M696.116,470.963v4h4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_28"
                      data-name="Line 28"
                      x1="5.6"
                      y2="5.6"
                      transform="translate(696.116 469.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_46"
                      data-name="Path 46"
                      d="M696.116,453.363v-4h4"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_29"
                      data-name="Line 29"
                      x1="5.6"
                      y1="5.6"
                      transform="translate(696.116 449.363)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_47"
                      data-name="Path 47"
                      d="M696.116,465.363l-3.2-3.2,3.2-3.2"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_30"
                      data-name="Line 30"
                      x2="8"
                      transform="translate(692.916 462.163)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_31"
                      data-name="Line 31"
                      y2="12.8"
                      transform="translate(711.316 467.763)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_32"
                      data-name="Line 32"
                      y2="20.8"
                      transform="translate(707.316 459.763)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <line
                      id="Line_33"
                      data-name="Line 33"
                      y1="20.8"
                      transform="translate(715.316 459.763)"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_48"
                      data-name="Path 48"
                      d="M711.316,451.763a3.067,3.067,0,0,0,3.2-3.2v-1.6a3.2,3.2,0,1,0-6.4,0v1.6A3.067,3.067,0,0,0,711.316,451.763Z"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                    <path
                      id="Path_49"
                      data-name="Path 49"
                      d="M715.316,468.563a3.374,3.374,0,0,0,3.2-3.2v-7.2c0-2.643-4.421-4-7.2-4s-7.2,1.357-7.2,4v7.2a3.373,3.373,0,0,0,3.2,3.2"
                      fill="none"
                      stroke="#222E50"
                      strokeLinejoin="round"
                      strokeWidth="0.8"
                    />
                  </g>
                </svg>
              </Col>
              <Col lg="6" className="d-lg-flex flex-column justify-content-between">
                <h2 className="mt-3 text-uppercase">En zie je wel wat in een uitdaging bij Synergie zelf?</h2>
                <p className="mt-3">
                  Goed gezien, want we doen er alles aan opdat Synergie-collega’s zich goed voelen bij ons, dag na dag.
                </p>
                <p>
                  Of je nu aan slag gaat als uitzendconsulent, inhouse consultant, kantoorverantwoordelijke of op een van onze
                  diensten op het hoofdkantoor, bij ons kan je elke dag jezelf zijn.
                </p>
                <p>
                  {' '}
                  Verken de mogelijkheden op{' '}
                  <a href="https://www.werkenbijsynergie.be" target="_blank" rel="noopener noreferrer">
                    werkenbijsynergie.be
                  </a>{' '}
                  en word <strong>happy@synergie</strong>!
                </p>
                <Row className="mt-3">
                  {testimonial && (
                    <Col xl="6" className="mt-2">
                      <a
                        href="https://www.werkenbijsynergie.be/colleagues/uD1hatmxFSjt9bJock0R/britt"
                        target="__blank"
                        rel="noopener noreferrer"
                      >
                        <Cta className="cta border-solid btn-outline-primary small w-100 cta-about" type="button">
                          Collega Britt vertelt het zelf
                        </Cta>
                      </a>
                    </Col>
                  )}
                  <Col xl="6" className="mt-2">
                    <a href="https://www.werkenbijsynergie.be" target="_blank" rel="noopener noreferrer">
                      <Cta className="cta red small w-100 cta-about" type="button">
                        Ga naar werken bij Synergie
                      </Cta>
                    </a>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </>
  );
}

export default AboutNl;
